import { render, staticRenderFns } from "./TaskContextDialog.vue?vue&type=template&id=651ec688"
import script from "./TaskContextDialog.vue?vue&type=script&lang=js"
export * from "./TaskContextDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskContextDialog.vue?vue&type=style&index=0&id=651ec688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports